import { lazy } from "react";
import AuthLayout from "../layout/Auth";
import GuestRoutes from "./GuestRoutes";

const Login = lazy(() => import("../Component/Auth/Login"));
const Register = lazy(() => import("../Component/Auth/Register"));
const ForgetPassword = lazy(() => import("../Component/Auth/ForgetPassword"));
const OtpVerify = lazy(() => import("../Component/Auth/OtpVerify"));
const NotFoundPage = lazy(()=> import("../Component/notFoundPage/NotFoundPage"));

const LoginRoutes = {
  path: "/auth",
  Component: GuestRoutes,
  children: [
    {
      path: "/auth",
      element: <AuthLayout />,
      children: [
        {
          path: "login",
          element: <Login />,
        },
        {
          path: "register",
          element: <Register />,
        },
        {
          path: "forget-password",
          element: <ForgetPassword/>,
        },
        {
          path: "otp-verification",
          element: <OtpVerify />,
        },
        {
          path: "*", element: <NotFoundPage/>
        }
      ],
    },
  ],
};

export default LoginRoutes;